import { gql } from '@apollo/client';

const GET_PAGES = gql`
  query ($bookListWhere: BookListWhereInput!, $pagesWhere: PagesWhereInput) {
    bookList(where: $bookListWhere) {
      instructions {
        id
        src
        description
        vtt
      }
      books {
        id
        type
        title
        bookCode
        orientation
        edition
        totalPages
        path
        locale
        offset
        url
        characters {
          id
          character
          characterType
          characterCase
        }
        pages(where: $pagesWhere) {
          id
          pageNumber
          src
          characters {
            id
            character
            characterType
            characterCase
          }
        }
      }
    }
  }
`;

export default GET_PAGES;
